import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import dropIcon from "../../images/icon/dropdown_icon.svg";
import premiumIcon from "../../images/icon/premium_icon.svg";
import editIcon from "../../images/icon/edit_icon.svg";
import translateIcon from "../../images/icon/translate_icon.svg";
import bookIcon from "../../images/icon/book_icon.svg";
import subtractIcon from "../../images/icon/subtract_icon.svg";
import micIcon from "../../images/icon/mic_icon.svg";
import backIcon from "../../images/icon/left-arrow-icon1.svg";
import puzzleIcon from "../../images/icon/puzzle_icon.svg";
import menuIcon from "../../images/icon/menu_icon.svg";
import timeIcon from "../../images/icon/time_icon.svg";
import tempIcon from "../../images/icon/temp_icon.svg";
import arrowRightIcon from "../../images/icon/arrow_right_icon.svg";
import shareIcon from "../../images/icon/share_icon3.svg";
import speakerIcon from "../../images/icon/speaker_icon.svg";
import userIcon from "../../images/icon/user_icon.svg";
import Drawer from "../components/drawer";
import Popover from "../components/popover";
import Tab from "../components/tab";

const dummyDat = [
  { title: "AI Specialists", icon: userIcon },
  { title: "Text Prompts", icon: bookIcon },
];
const AIDummyData = [
  {
    id: 7,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Startup Tech Lawyer",
    description:
      "Legal expert specializes in intellectual properties, contracts & regulatory compliance.",
    user: "test@09",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 8,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Life Coach",
    description:
      "A life coach who can help you set and achieve personal & professional goals.",
    user: "test@99",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 9,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Career Counselor",
    description:
      "A career counselor who can give professional advice on your future career path",
    user: "test@00",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 10,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Pet Behaviour Expert",
    description:
      "A pet behaviour expert helps you understand and address your pet's behavioral issues.",
    user: "test@890",
    startActive: false,
    children: [],
    isExpanded: false,
  },
];
const TextPromptDummyData = [
  {
    id: 11,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Create business card",
    description: "Generate idea for creative business card with minimalistic..",
    user: "test@798",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 12,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Digital marketing campaign",
    description:
      "Content strategy for marketing campaign featuring futuristic AI",
    user: "test@56",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 13,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Fintech pitch deck",
    description: "Create a pitch deck for a fintech startup company",
    user: "test@345",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 14,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "Cryptocurrency trading",
    description: "Explain how cryptocurrency trading and NFT works",
    user: "test@0934",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 15,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "List item",
    description: "Explain how cryptocurrency trading and NFT works",
    user: "test@01237",
    startActive: false,
    children: [],
    isExpanded: false,
  },
  {
    id: 16,
    profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      Math.random() * (50 - 1 + 1) + 1
    )}.jpg`,
    title: "List item",
    description: "Explain how cryptocurrency trading and NFT works",
    user: "test@0912",
    startActive: false,
    children: [],
    isExpanded: false,
  },
];
const RightSection = ({
  selectedProfile,
  setSelectedProfile,
  setUserList,
  userList,
  isMobile,
  googleLogin,
  logoutHandler,
}) => {
  const { loggedIn } = useSelector((state) => state.auth);
  const [selectedTab, setSelectedTab] = useState(0);
  const [message, setMessage] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const chatRef = useRef(null);
  const chatHandler = () => {
    const clone = [...userList];
    const findUserIndex = userList?.findIndex(
      (item) => item?.id === selectedProfile?.id
    );
    if (findUserIndex !== -1) {
      clone[findUserIndex].chatList =
        [
          ...clone[findUserIndex]?.chatList,
          { message: message, user: "you" },
        ] || [];
      setTimeout(() => {
        chatRef.current.scrollTop = chatRef.current.scrollHeight;
      }, 1);
      setSelectedProfile(clone[findUserIndex]);
    }
    setMessage("");
    setUserList(clone);
  };

  const createNewChatHandler = (item) => {
    const newValue = {
      ...item,
      title: "Search Title",
      description: "Short Description",
      chatList: [],
    };
    setUserList((pre) => [...pre, newValue]);
    setSelectedProfile(newValue);
  };
  const shareChatHandler = (chatItem) => {
    const newChatCreate = {
      ...selectedProfile,
      id: Math.floor(Math.random() * (1000 - 1 + 1) + 1),
      title: `List Item ${Math.floor(Math.random() * (50 - 1 + 1) + 1)}`,
      description: `Short Description ${Math.floor(
        Math.random() * (50 - 1 + 1) + 1
      )}`,
      // profileUrl: `https://xsgames.co/randomusers/assets/avatars/pixel/${Math.floor(
      //   Math.random() * (50 - 1 + 1) + 1
      // )}.jpg`,
      chatList: [],
      // user: chatItem?.user,
    };
    setMessage(chatItem?.message);
    setSelectedProfile(newChatCreate);
    setUserList((pre) => [...pre, newChatCreate]);
  };
  return (
    <div
      className={
        "bg-transparent h-full w-full sm:w-full md:w-8/12 lg:w-4/5 p-4 py-8 sm:p-6 flex flex-col gap-4 justify-between text-white items-center"
      }
    >
      <div
        className={"flex flex-row justify-between w-full items-center gap-2"}
      >
        <div className={"flex flex-row gap-4 items-center"}>
          {isMobile && selectedProfile?.user && (
            <img
              src={backIcon}
              alt={"back"}
              className={"w-[20px] cursor-pointer"}
              onClick={() => {
                setSelectedProfile(null);
              }}
            />
          )}

          <button
            className={
              "p-2 backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] rounded-lg font-semibold text-base flex flex-row items-center gap-2"
            }
          >
            <span className={"truncate"}>GPT 4.0 Model </span>
            <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
          </button>
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] rounded-lg font-semibold text-base hidden sm:hidden md:flex lg:flex flex-row items-center gap-2"
            }
          >
            <img src={tempIcon} alt={"tempIcon"} className={"w-[20px]"} />
            <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
          </button>
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] rounded-lg font-semibold text-base hidden sm:hidden md:flex lg:flex flex-row items-center gap-2"
            }
          >
            <img src={puzzleIcon} alt={"puzzleIcon"} className={"w-[20px]"} />
            <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
          </button>
        </div>

        <div
          className={
            "hidden sm:hidden md:flex lg:flex flex-row gap-4 items-center"
          }
        >
          <button
            className={
              "p-2 backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] rounded-lg font-semibold text-base flex flex-row items-center gap-2"
            }
          >
            <img src={premiumIcon} alt={"premiumIcon"} className={"w-[20px]"} />
            <span className={"truncate"}>Go Premium</span>
          </button>
          {loggedIn ? (
            <div className={"flex flex-row items-center gap-2"}>
              <div
                className={
                  "border-2 border-white rounded-full w-[40px] h-[40px] flex items-center justify-center bg-buttonPrimary font-semibold cursor-pointer"
                }
              >
                AT
              </div>
              <Popover
                content={
                  <div className={"flex flex-col"}>
                    <span
                      className={
                        "p-3 px-4 cursor-pointer hover:bg-[#e7e7e799] rounded-lg font-semibold"
                      }
                    >
                      Settings
                    </span>
                    <div className={`w-full border-t-2 border-[#F3F3F4]`} />
                    <span
                      className={
                        "p-3 px-4 cursor-pointer hover:bg-[#e7e7e799] rounded-lg font-semibold"
                      }
                    >
                      Profile
                    </span>
                    <div className={`w-full border-t-2 border-[#F3F3F4]`} />
                    <span
                      className={
                        "p-3 px-4 cursor-pointer hover:bg-[#e7e7e799] rounded-lg font-semibold"
                      }
                      onClick={logoutHandler}
                    >
                      Logout
                    </span>
                  </div>
                }
                afterOpenChildren={
                  <img
                    src={dropIcon}
                    alt={"dropIcon"}
                    className={"w-[30px] cursor-pointer rotate-180"}
                  />
                }
              >
                <img
                  src={dropIcon}
                  alt={"dropIcon"}
                  className={"w-[30px] cursor-pointer"}
                />
              </Popover>
            </div>
          ) : (
            <button
              className={
                "p-2 backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] rounded-lg font-semibold text-base flex-row items-center gap-2 w-[78px] flex justify-center"
              }
              onClick={googleLogin}
            >
              Login
            </button>
          )}
        </div>
        <button
          className={"flex sm:flex md:hidden lg:hidden cursor-pointer"}
          onClick={() => setIsDrawerOpen(true)}
        >
          <img src={menuIcon} alt={"menuIcon"} className={"w-[20px]"} />
        </button>
      </div>
      {selectedProfile?.user ? (
        <div className={"h-full w-full flex flex-col items-center gap-4"}>
          <div
            className={"flex flex-col gap-2 w-full justify-center items-center"}
          >
            <div className={"relative flex flex-col"}>
              <img
                src={selectedProfile?.profileUrl}
                alt={"profile"}
                className={"rounded-full w-[150px]"}
              />
              <button
                className={
                  "bg-white border-2 border-[#D9D8DC] p-2 rounded-full w-[45px] h-[45px] absolute bottom-0 right-0 flex flex-col justify-center items-center"
                }
              >
                <img src={editIcon} className={"w-[20px]"} alt={"editIcon"} />
              </button>
            </div>
            <div className={"flex flex-col w-full justify-center items-center"}>
              <span className={"text-xl font-semibold"}>
                {selectedProfile?.user}
              </span>
              <span className={"text-lg text-[#8C8A94] font-semibold"}>
                Legal expert specializes in intellectual properties, contracts &
                regulatory compliance.
              </span>
            </div>
            <div className={"flex flex-row gap-4"}>
              <button
                className={
                  "bg-[#0BABFB] hover:bg-[#2d293b8f] hover:backdrop-blur-md px-4 py-2  border border-[#0BABFB] rounded-[8px] flex flex-row items-center justify-center gap-[4px] font-semibold text-base"
                }
              >
                <img
                  src={translateIcon}
                  alt={"translateIcon"}
                  className={"w-[20px]"}
                />
                English
                <img src={dropIcon} alt={"dropIcon"} className={"w-[20px]"} />
              </button>
              <button
                className={
                  "bg-[#2d293bad] hover:bg-[#2d293b8f] hover:backdrop-blur-md px-4 py-2 border border-[#0BABFB] rounded-[8px] flex flex-row items-center justify-center gap-[4px] font-semibold text-base"
                }
              >
                <img src={timeIcon} alt={"timeIcon"} className={"w-[20px]"} />
                1
                <img src={dropIcon} alt={"dropIcon"} className={"w-[20px]"} />
              </button>
            </div>
          </div>
          <div
            className={
              "w-full h-full max-h-[390px] flex flex-col gap-4 max-w-[600px] px-4 no-scrollbar overflow-auto scroll-auto"
            }
            ref={chatRef}
          >
            {selectedProfile?.chatList?.map((item, index) => {
              return (
                <div
                  key={`chat_${index}`}
                  className={`flex flex-col w-full gap-1 group cursor-pointer ${
                    item?.user === "you" ? "items-end" : "items-start"
                  }`}
                >
                  <div
                    className={`flex gap-2 w-full ${
                      item?.user === "you" ? "flex-row-reverse" : "flex-row"
                    }`}
                    key={`chat_id_${index}`}
                    style={{
                      justifyContent: item?.user === "you" ? "end" : "start",
                    }}
                  >
                    <div className={"w-[40px]"}>
                      {item?.user === "you" ? (
                        <div
                          className={
                            "border-2 border-white rounded-full w-[40px] h-[40px] flex items-center justify-center bg-buttonPrimary font-semibold cursor-pointer"
                          }
                        >
                          AT
                        </div>
                      ) : (
                        <img
                          src={selectedProfile?.profileUrl}
                          alt={"profile"}
                          className={"rounded-full w-[40px]"}
                        />
                      )}
                    </div>
                    <div
                      className={
                        "py-2 px-4 rounded-[8px] bg-[#2d293b] text-white font-medium"
                      }
                    >
                      {item?.message?.split("\n").map((item) => {
                        return <div className={"break-all"}>&nbsp;{item}</div>;
                      })}
                    </div>
                  </div>
                  <div className={"hidden group-hover:flex flex-row gap-2"}>
                    <div
                      className={
                        "text-white backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] px-2 py-1 rounded-md cursor-pointer flex flex-row items-center gap-2"
                      }
                      onClick={() => shareChatHandler(item)}
                    >
                      Start a new chat{" "}
                      <img
                        src={shareIcon}
                        className={"w-[20px]"}
                        alt={"shareIcon"}
                      />
                    </div>
                    <div
                      className={
                        "text-white backdrop-blur-xl bg-[#2d293bad] hover:bg-[#2d293b8f] border border-[#8c8a9478] px-2 py-1 rounded-md cursor-pointer flex justify-center"
                      }
                    >
                      <img
                        src={speakerIcon}
                        className={"w-[20px]"}
                        alt={"speakerIcon"}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div
          className={
            "flex flex-col justify-center items-center w-full h-full gap-2"
          }
        >
          <div
            className={
              "w-full max-w-[700px] flex flex-col justify-center items-center gap-2"
            }
          >
            <Tab
              tabList={dummyDat}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            >
              {selectedTab === 0 && (
                <div className={"w-full h-[600px] overflow-auto no-scrollbar"}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 grid-flow-row gap-4">
                    {AIDummyData?.map((item, index) => {
                      return (
                        <div
                          className={
                            "backdrop-blur-xl bg-chatCardBG p-4 py-8 rounded-[20px] flex flex-col items-center justify-center gap-2 cursor-pointer border-2 border-[#8c8a9478]"
                          }
                          key={`AI_Card_${index}`}
                        >
                          <img
                            src={item?.profileUrl}
                            alt={item.title}
                            className={"rounded-full w-[120px]"}
                          />
                          <div
                            className={
                              "flex flex-col overflow-auto no-scrollbar h-[100px]"
                            }
                          >
                            <span
                              className={"font-semibold text-lg text-center"}
                            >
                              {item?.title}
                            </span>
                            <span
                              className={
                                "text-base text-[#8C8A94] font-semibold text-center"
                              }
                            >
                              {item?.description}
                            </span>
                          </div>
                          <div className={"flex w-full justify-end"}>
                            <img
                              src={arrowRightIcon}
                              alt={"arrowRightIcon"}
                              className={"w-[40px]"}
                              onClick={() => createNewChatHandler(item)}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {selectedTab === 1 && (
                <div className={"w-full h-[600px]  overflow-auto no-scrollbar"}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 grid-flow-row gap-4">
                    {TextPromptDummyData?.map((item, index) => {
                      return (
                        <div
                          className={
                            "backdrop-blur-md bg-chatCardBG p-4 rounded-[16px] flex flex-col gap-2 cursor-pointer border-2 border-[#8c8a9478]"
                          }
                          key={`text_prompt_${index}`}
                        >
                          <div className={"flex flex-row gap-2"}>
                            <img
                              src={item?.profileUrl}
                              alt={item?.title}
                              className={"w-[50px] h-[50px]"}
                            />
                            <div
                              className={
                                "flex flex-col gap-1 overflow-auto no-scrollbar h-[120px]"
                              }
                            >
                              <span className={"font-semibold text-lg"}>
                                {item?.title}
                              </span>
                              <span
                                className={
                                  "text-base text-[#8C8A94] font-semibold"
                                }
                              >
                                {item?.description}
                              </span>
                            </div>
                          </div>
                          <div className={"flex w-full justify-end"}>
                            <img
                              src={arrowRightIcon}
                              alt={"arrowRightIcon"}
                              className={"w-[40px]"}
                              onClick={() => createNewChatHandler(item)}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </Tab>
            <span className={"text-[#B3B1B8] text-start w-full text-base"}>
              Select an avatar to start your question...
            </span>
          </div>
        </div>
      )}

      <div className={"w-full flex flex-col justify-center items-center"}>
        <div className={"flex justify-center gap-4 w-full"}>
          <img
            src={bookIcon}
            alt={"bookIcon"}
            className={"w-[30px] cursor-pointer"}
          />
          <textarea
            placeholder={"Generate something..."}
            className={`p-4 w-full border-0 max-w-[600px] ${
              message?.length > 100 ? "h-[200px]" : "h-auto"
            } rounded-[8px] bg-[#2d293b] text-white font-medium outline-0 max-h-[90px] placeholder-[#8C8A94] placeholder:truncate disabled:cursor-not-allowed no-scrollbar`}
            rows={1}
            disabled={!selectedProfile?.user}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={(e) => {
              if (!e?.shiftKey && e.key === "Enter") {
                e.preventDefault();
                chatHandler();
                setMessage("");
              }
            }}
          />
          <img
            src={subtractIcon}
            alt={"subtractIcon"}
            className={"w-[30px] cursor-pointer"}
            // onClick={chatHandler}
          />
          <img
            src={micIcon}
            alt={"micIcon"}
            className={"w-[30px] cursor-pointer"}
          />
        </div>
        <span className={"max-w-[640px] w-full text-[#8c8a94] font-semibold"}>
          Please Enter to send
        </span>
      </div>
      <Drawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen}>
        <div className={"px-4 py-6"}>
          <img
            src={backIcon}
            alt={"back"}
            className={"w-[20px] cursor-pointer"}
            onClick={() => setIsDrawerOpen(false)}
          />
        </div>
        <div className={"p-4 flex flex-col gap-3"}>
          {loggedIn ? (
            <div className={"flex flex-col justify-center items-center"}>
              <div
                className={
                  "border-2 border-white rounded-full w-[90px] h-[90px] text-2xl flex items-center justify-center bg-buttonPrimary font-semibold cursor-pointer"
                }
              >
                AT
              </div>
            </div>
          ) : (
            <div
              className={
                "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
              }
              onClick={googleLogin}
            >
              Login
            </div>
          )}
          <div
            className={
              "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
            }
          >
            Settings
          </div>
          <div
            className={
              "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
            }
          >
            Profile
          </div>
          {loggedIn && (
            <div
              className={
                "p-4 rounded hover:bg-[#1e1e1ec2] cursor-pointer font-semibold"
              }
              onClick={() => {
                logoutHandler();
                setIsDrawerOpen(false);
              }}
            >
              Logout
            </div>
          )}
          <div className={`w-full border-t-2 border-[#8C8A94]`} />

          <div className={"flex flex-row gap-4 w-full"}>
            <button
              className={
                "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2 w-full"
              }
            >
              <img src={tempIcon} alt={"tempIcon"} className={"w-[20px]"} />
              <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
            </button>
            <button
              className={
                "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2 w-full"
              }
            >
              <img src={puzzleIcon} alt={"puzzleIcon"} className={"w-[20px]"} />
              <img src={dropIcon} alt={"drop"} className={"w-[20px]"} />
            </button>
          </div>

          <button
            className={
              "p-2 border-2 border-white rounded-lg font-semibold text-base flex flex-row items-center justify-center gap-2"
            }
          >
            <img src={premiumIcon} alt={"premiumIcon"} className={"w-[20px]"} />
            Go Premium
          </button>
        </div>
      </Drawer>
    </div>
  );
};
export default RightSection;
